export type AccentTone = "primary" | "accent" | "secondary";

export function categoryBadgeClass(accent: AccentTone): string {
  if (accent === "accent") return "bg-accent-100 text-accent-900";
  if (accent === "secondary") return "bg-secondary-100 text-secondary-900";
  return "bg-primary-100 text-primary-900";
}

export function levelBadgeClass(level: string): string {
  if (level === "Avançado") return "bg-foreground-900 text-background-50";
  if (level === "Intermediário") return "bg-accent-100 text-accent-900";
  return "bg-secondary-100 text-secondary-900";
}